"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { getSuggestions } from "@/lib/api/suggestions";

export function useSuggestions(query: string, kind: string) {
  const locale = useLocale();
  return useQuery({
    queryKey: ["suggestions", kind, query, locale],
    queryFn: () => getSuggestions(query, kind, locale),
    enabled: query.length >= 3,
    staleTime: 30_000,
  });
}
